<dx-data-grid
  style="height: 100%"
  (onRowRemoved)="dataChanged.emit()"
  [columnAutoWidth]="true"
  [dataSource]="metrics"
  [repaintChangesOnly]="true"
  [showBorders]="true"
  [showColumnLines]="false"
  [showRowLines]="false"
  [wordWrapEnabled]="true">

  <dxo-row-dragging
    [allowReordering]="!disabled"
    [dragDirection]="'vertical'"
    [onReorder]="reorderItem"
    [showDragIcons]="!disabled">
  </dxo-row-dragging>

  <dxo-editing
    [allowDeleting]="!disabled"
    [allowUpdating]="!disabled"
    [confirmDelete]="false"
    [mode]="'cell'"
    [startEditAction]="'click'"
    [useIcons]="true">
  </dxo-editing>

  <dxi-column
    [allowEditing]="false"
    [dataField]="'metricInstance.partitionName'"
    [editCellTemplate]="'disabledCellTemplate'"
    [showEditorAlways]="true"
    caption="{{ 'DASHBOARD.REPORTS.METRIC_PARTITION' | translate }}">
  </dxi-column>

  <dxi-column
    [allowEditing]="false"
    [dataField]="'metricInstance.deviceName'"
    [editCellTemplate]="'disabledCellTemplate'"
    [showEditorAlways]="true"
    caption="{{ 'DASHBOARD.REPORTS.METRIC_DEVICE' | translate }}">
  </dxi-column>

  <dxi-column
    [allowEditing]="false"
    [dataField]="'metricInstance.name'"
    [editCellTemplate]="'disabledCellTemplate'"
    [showEditorAlways]="true"
    caption="{{ 'DASHBOARD.REPORTS.METRIC_NAME' | translate }}">
  </dxi-column>

  <dxi-column
    [dataField]="'functionType'"
    [editCellTemplate]="'functionTypeSelector'"
    [showEditorAlways]="true"
    caption="{{ 'DASHBOARD.REPORTS.METRIC_FUNCTION' | translate }}">
    <dxo-lookup
      [dataSource]="functionTypeValues"
      [displayExpr]="translateFunctionType">
    </dxo-lookup>
  </dxi-column>

  <div *dxTemplate="let cellInfo of 'disabledCellTemplate'" style="color: darkgray; padding: 10px 11px;">
    {{ cellInfo.value }}
  </div>

  <div *dxTemplate="let cellInfo of 'functionTypeSelector'">
    <dx-select-box
      (onValueChanged)="setSelectorValue($event, cellInfo)"
      [dataSource]="functionTypeValues"
      [disabled]="disabled"
      [displayExpr]="translateFunctionType"
      [value]="cellInfo.value"
      class="noPaddingCell">
    </dx-select-box>
  </div>

</dx-data-grid>
